import React, { createContext, useContext, useState } from 'react';
import { GameThemeContextModel } from './GameTheme.model';

const GameThemeContext = createContext<GameThemeContextModel>({
  gameId: null,
  getGameId: null,
  setGameId: null,
});

export const useGameTheme = (): GameThemeContextModel => useContext(GameThemeContext);

const useProvideGameTheme = (): GameThemeContextModel => {
  const [gameId, setCurrentGameId] = useState<string>('');

  const setGameId = (id: string): void => {
    setCurrentGameId(id);
  };

  const getGameId = (): string => (gameId);

  return {
    gameId,
    setGameId,
    getGameId,
  };
};

export function ProvideGameTheme(props: {
  children?: JSX.Element | JSX.Element[];
}): JSX.Element {
  const gameTheme = useProvideGameTheme();

  return (
    <GameThemeContext.Provider value={gameTheme}>
      {props.children}
    </GameThemeContext.Provider>
  );
}
